import { Typography, Button, Dialog, DialogContent, DialogActions } from "@mui/material";
import React, { Fragment } from "react";

function ResponseDialog({ open, onClose, dataResponse }) {

    return (
        <Fragment>
            <Dialog
                maxWidth={'sm'}
                open={open}
            >
                <DialogContent>
                    <Typography variant="body1">{dataResponse}</Typography>
                </DialogContent>
                <DialogActions className='m-4 gap-1'>
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        size='small'
                        style={{
                            color: "#000",
                            borderColor: "#ccc",
                        }}
                    >
                        ปิด
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}

export default ResponseDialog